<template>
  <v-card flat class="no-margins">
    <v-tour name="myTour" :steps="steps" :options="tourOptions">
      <template slot-scope="tour">
        <transition>
          <template>
            <v-step
              v-if="tour.currentStep === index"
              v-for="(step, index) of tour.steps"
              :key="index"
              :step="step"
              :previous-step="tour.previousStep"
              :next-step="tour.nextStep"
              :stop="tour.stop"
              :is-first="tour.isFirst"
              :is-last="tour.isLast"
              :labels="tour.labels"
            >
              <!-- <templatev-if="tour.currentStep > 0 && (tour.currentStep<tour.steps.length - 1)"> -->
              <template>
                <div slot="actions" class="v-step__buttons">
                  <v-icon @click="tour.stop, stopTour()" class="v-step__close">$sl-close</v-icon>
                  <button
                    v-if="tour.currentStep==0"
                    @click="tour.stop, stopTour()"
                    class="v-step__button v-step__button"
                  >Avsluta</button>

                  <button
                    v-if="tour.currentStep > 0"
                    @click="tour.previousStep"
                    class="v-step__button v-step__button"
                  >Föregående steg</button>
                  <button
                    v-if="tour.currentStep<(tour.steps.length - 1)"
                    @click="tour.nextStep"
                    class="v-step__button v-step__button"
                  >Nästa steg</button>

                  <button
                    v-if="tour.currentStep == (tour.steps.length - 1)"
                    @click="tour.stop"
                    class="v-step__button v-step__button"
                  >Avsluta</button>
                </div>
              </template>
            </v-step>
          </template>
        </transition>
      </template>
    </v-tour>
  </v-card>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'

export default {
  name: 'sitetour',
  props: {
    open: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    tourOptions: {
      useKeyboardNavigation: true,
      highlight: false,
      labels: {
        buttonNext: 'Nästa steg',
        buttonPrevious: 'Föregående steg',
        buttonSkip: 'Avsluta',
        buttonStop: 'Avsluta'
      }
    },
    steps: []
  }),
  watch: {
    open: {
      handler: function () {
        this.init()
      }
    }
  },
  created() {
    this.init()
  },
  mounted() {
    this.startTour()
  },
  computed: {
    ...mapGetters('currentuser', ['currentUser'])
  },
  methods: {
    ...mapActions('currentuser', ['setCurrentUser']),
    init() {
      this.steps = [
        {
          target: '.v-step-0',
          header: {
            title: 'Så här kommer du igång med Registret 4.0'
          },
          content:
            'Hej och välkommen till den nya versionen av Registret. Denna guide ger dig en översikt över de viktigaste funktionerna. <br><br>På <a href="http://www.byn.se" target="_blank">BYN:s intranät finns videofilmer</a> som visar hur man utför ett antal vanliga eller återkommande arbetsmoment i Registret.',
          params: {
            placement: 'top',
            modifiers: {
              arrow: {
                element: '.v-step__arrow'
              }
            }
          }
        },
        {
          target: '.v-step-1',
          header: {
            title: 'Översikt'
          },
          content:
            'På Registrets översiktsida får du en snabb överblick över aktuella ärenden som väntar på godkännande:<br><br><ul><li>Lärlingsanmälningar</li><li>Yrkesbevis</li><li>Ansökningar om maskinslag.</li><li>Dispenser</li></ul><br>Vilka ärenden du ser beror på dina behörigheter på Registret och vilken region du tillhör.',
          params: {
            placement: 'left-start',
            modifiers: {
              arrow: {
                element: '.v-step__arrow'
              }
            }
          }
        },
        {
          target: '.v-step-2',
          header: {
            title: 'Personer'
          },
          content:
            'På sidan "personer" ser du vilka individer som finns inlagda i systemet. Du ser i regel de personer som tillhör din region såvida du inte har behörighet att se alla i landet. Klicka på en rad för att gå till personens sida.<br><br>Klicka på plusknappen för att lägga till en person i Registret. Du kan antingen ange personnummer och ange kontaktuppgifter för hand eller hämta dem från Statens person- och adressregister (SPAR).<br><br>När du klickar på en person visas personvyn. Här kan du se och redigera kontaktinformationen för personen. Du kan se anställningar och lärlingsperioder, yrkesbevis samt de ärenden och beställningar som gäller personen. Om du är administratör kan du även se när personen senast loggade in samt spärra, inaktivera och radera kontot.',
          params: {
            placement: 'left-start',
            modifiers: {
              arrow: {
                element: '.v-step__arrow'
              }
            }
          }
        },
        {
          target: '.v-step-3',
          header: {
            title: 'Företag'
          },
          content:
            'På sidan "företag" visas medlemsföretagen i din region, såvida du inte har behörighet att se företag i andra regioner också. Genom att klicka på plusknappen kan du lägga till ett företag och hämta dess uppgifter från Bolagsverket eller ange dem för hand.<br><br>Om du klickar på ett företag visas företagsvyn. På den sidan ser du information om företaget och kan se vilka tillsvidareanställningar som finns registrerade. Du kan även se andra anställda som företaget kopplat via Mina sidor. Under fliken “arbetsplatser” visas de arbetsplatser som företaget lagt in genom Mina sidor.',
          params: {
            placement: 'left-start',
            modifiers: {
              arrow: {
                element: '.v-step__arrow'
              }
            }
          }
        },
        {
          target: '.v-step-4',
          header: {
            title: 'Lärlingsanmälningar'
          },
          content:
            'På sidan "anmälningar" (eller "lärlingsanmälningar") visas inkomna lärlingsanmälningar. Du kan söka och sortera anmälningarna beroende på status, datum m.m.<br><br>Om du klickar på en anmälan visas den i en egen vy. På denna sida kan du se information om den sökande och företaget anmälan gäller.<br><br>Genom att klicka på pennikonen kan du ändra uppgifterna på sidan.<br><br>Under rubriken “meddelanden” ser du vilka meddelanden som skickats och skapats i samband med lärlingsanmälan.<br><br>Längst ned finns knappar för att neka, radera eller godkänna en anmälan.',
          params: {
            placement: 'left-start',
            modifiers: {
              arrow: {
                element: '.v-step__arrow'
              }
            }
          }
        },
        {
          target: '.v-step-5',
          header: {
            title: 'Beställningar'
          },
          content:
            'På sidan "beställningar" visas beställningar av distansutbildning. Du kan söka, sortera och filtrera beställningarna.<br><br>Om du klickar på en beställning ser du mer information. Beställningsvyn visar ett fakturaunderlag med fakturauppgifter och orderrader. Informationen på denna sida kan du skriva ut, ladda ned som en Visma-kompatibel XML-fil, skicka en kopia av underlaget som e-post eller skicka underlaget till ekonomisystemet för fakturering.<br><br>Under fliken "beställning" finns mer information om beställningen, vilka utbildningsmoduler (kurser) som ingår. Du kan även justera önskat startdatum för utbildningen.<br><br>På fliken "kommentarer" kan du bifoga en kommentar till beställningen. Detta kan vara till hjälp för andra som behandlar samma ärende.',
          params: {
            placement: 'left-start',
            modifiers: {
              arrow: {
                element: '.v-step__arrow'
              }
            }
          }
        },
        {
          target: '.v-step-6',
          header: {
            title: 'Användare'
          },
          content:
            'På sidan "användare" listas Registrets användare. Registretanvändare med administratörsbefogenheter har möjlighet att ändra information om andra användare.<br><br>Obs! Denna sida visar inte användarna på Mina sidor.',
          params: {
            placement: 'left-start',
            modifiers: {
              arrow: {
                element: '.v-step__arrow'
              }
            }
          }
        },
        {
          target: '.v-step-0',
          header: {
            title: 'Det var allt'
          },
          content:
            'Nu har du fått en överblick över Registret. Du kan när som helst öppna den här guiden igen genom att klicka på "Guide" i menyn.<br><br>Mer information finns också i manualen för Registret som du hittar på <a href="https://byns.sharepoint.com/SitePages/Register4.aspx" target="_blank">BYN:s intranät</a>.'
        }
      ]
    },
    stopTour() {
      this.$tours['myTour'].stop()
      if (this.$vuetify.breakpoint.mdAndDown == true) {
        
        setTimeout(() => { this.$events.fire('closeLeftMenu'); }, 1000);
      }
    },
    startTour() {
      if (this.open == true) {
        this.$tours['myTour'].start()
      }
    }
  }
}
</script>

<style scoped>
</style>